const mediaItems = [
  {
    id: 1,
    title: '某顶流男星夜会神秘女子，工作室紧急公关删帖',
    source: '51黑料网站',
    views: '128.6万',
    time: '3小时前',
    tag: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20editorial%20scene%20with%20dramatic%20warm%20lighting%2C%20dark%20moody%20atmosphere%2C%20modern%20minimalist%20composition%2C%20geometric%20shapes%20and%20soft%20gradients%2C%20coral%20and%20amber%20accents%2C%20no%20text&width=640&height=360&seq=media-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '网红带货翻车实录：百万粉丝博主直播现场被扒皮',
    source: '91黑料网站',
    views: '96.3万',
    time: '5小时前',
    tag: '网红翻车',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20composition%20with%20moody%20dark%20warm%20tones%2C%20dramatic%20spotlight%20effect%2C%20abstract%20geometric%20pattern%2C%20suggesting%20live%20streaming%20and%20social%20media%20drama%2C%20rich%20amber%20and%20deep%20coral%20gradients%2C%20no%20text&width=640&height=360&seq=media-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '选秀节目黑幕录音流出，三位选手联合发声维权',
    source: '吃瓜黑料网站',
    views: '215.7万',
    time: '8小时前',
    tag: '综艺内幕',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20editorial%20scene%20with%20warm%20burgundy%20and%20deep%20amber%20lighting%2C%20abstract%20stage-like%20composition%2C%20soft%20glow%20highlights%2C%20geometric%20forms%2C%20cinematic%20atmosphere%2C%20no%20text&width=640&height=360&seq=media-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '知名女星代孕疑云再添实锤，知情人士曝关键证据',
    source: '51黑料网站',
    views: '187.2万',
    time: '12小时前',
    tag: '明星八卦',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20editorial%20composition%2C%20warm%20coral%20and%20deep%20rose%20tones%2C%20abstract%20overlapping%20geometric%20forms%2C%20soft%20dramatic%20lighting%2C%20modern%20minimalist%20aesthetic%2C%20no%20text&width=640&height=360&seq=media-4-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '娱乐圈资本局揭秘：某影视公司背后对赌协议曝光',
    source: '91黑料网站',
    views: '73.9万',
    time: '1天前',
    tag: '行业揭秘',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20scene%20with%20warm%20terracotta%20and%20amber%20gradients%2C%20dark%20atmospheric%20composition%2C%20abstract%20geometric%20shapes%20suggesting%20financial%20and%20corporate%20themes%2C%20soft%20glow%2C%20no%20text&width=640&height=360&seq=media-5-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            最新爆料视频
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选全网热门黑料视频内容，吃瓜不迷路
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-white/70 text-xs whitespace-nowrap">{item.time}</span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 backdrop-blur-sm">
                  <i className="ri-play-fill text-white text-xl"></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-relaxed group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">来源：{item.source}</span>
                  <span className="flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}